import React from "react";
import { scroller, Events, scrollSpy } from "react-scroll";
import { ChatStyles } from "./styles.module";
import { Icon } from "../../../components/UIKitComponents/Icon/Icon";
import { Modal } from "../../../components/UIKitComponents/Modal/Modal";
import { Job } from "../../../models/Booking/Job";
import { ContactTypes } from "../../constants";
import { customerUrl, techUrl } from "../../../helpers/Common";

import { MessagesStyles } from "../Messages/styles.module";

import { Spinner } from "../../../components/UIKitComponents/Spinner/Spinner";
import { MessageItem } from "../MessageItem/MessageItem";
import WriterContainer from "../Writer/Writer.Container";

// import { ContactMenu } from "../ContactMenu/ContactMenu";
// import OutboundPopupContainer from "../../../components/OutboundPopup/Technicians/OutboundPopup.Container";
// import OutboundPopupLocations from "../../../components/OutboundPopup/Locations/OutboundPopupLocations.Container";
import { formattedPhone } from "../../../helpers/PhoneHelper";

import { ChatDateItem } from "./ChatDateItem";
import { ContactInfo } from "../ContactInfo/ContactInfo";
import { isSameDay } from "date-fns";
import { DispatchToProps, StateToProps } from "./Chat.Container";

function vsbl(ln: number, index: number): boolean {
  const visibilityCount = 5;
  return ln - visibilityCount < 0
    ? true
    : ln - visibilityCount > 0 && index > ln - visibilityCount;
}

interface IContactsListProps {
  // tеchnician_contacts: any;
  // customer_contacts: any;
  // contacts : any;
  // contactType : number;
  // activeContactIndex: number;
  // chat : any[];
  // chatLoadingIndicator : boolean;
}

type Props = IContactsListProps & StateToProps & DispatchToProps;

export class Chat extends React.Component<Props> {
  refMessagesWrap: any;

  state: any = {
    techModalShown: false,
    customerInfoModalShown: false,
    job: new Job(),
    scrollTopPosition: 0,
  };

  scrollListener = (event: any) => {
    // React.UIEvent<HTMLElement>
    const scrollTop = event?.target?.scrollTop;
    // const msgWrapOffsets = this.refMessagesWrap.getBoundingClientRect();

    this.setState({ scrollTopPosition: scrollTop });

    // console.log(`SCROLL::scrollTop: ${scrollTop}`, msgWrapOffsets);
  };

  componentDidUpdate(prevProps: any, prevState: any, snapshot: any) {
    const activeContact =
      this.props?.contacts[this.props?.activeContactIndex] || {};
    const prevActiveContact =
      prevProps?.contacts[prevProps?.activeContactIndex] || {};

    if (prevProps.chat?.length < this.props.chat?.length) {
      this.scrollToBottom();
    }
    if (activeContact.phone != prevActiveContact.phone) {
      console.log("SCROLL::componentDidUpdate::", arguments);

      //
      // Здесь нужно отслеживать скролл в ыерхнюю часть чата
      //
      let scrollEl = document.querySelector("#messages-wrapper");

      scrollEl && scrollEl.removeEventListener("scroll", this.scrollListener);
      scrollEl && scrollEl.addEventListener("scroll", this.scrollListener);
    }
  }

  onChangeOutboundPopupLocation(id: number, departmentId: number) {
    const job = this.state.job;
    job.location_id = id;
    job.department_id = departmentId;
    this.setState({ job: job });
  }

  toggleCustomerInfoModal() {
    this.setState({
      customerInfoModalShown: !this.state.customerInfoModalShown,
    });
  }

  toggleOutboundTechModal() {
    this.setState({
      techModalShown: !this.state.techModalShown,
    });
  }

  getFIO(contact: any) {
    let firstletter = contact.original?.first_name || "-";
    let lastletter = contact.original?.last_name || "-";

    firstletter = firstletter[0]?.toUpperCase();
    lastletter = lastletter[0]?.toUpperCase();

    return {
      firstletter,
      lastletter,
    };
  }

  scrollToBottom() {
    scroller.scrollTo("end-of-chat", {
      duration: 100,
      smooth: false,
      containerId: "messages-wrapper",
      offset: 20, // Scrolls to element + 50 pixels down the page
    });
  }

  outboundFieldNames() {
    return {
      popupTitle: "Outbound call",
      selector: {
        title: "Location",
        placeholder: "Search location",
      },
      outboundPhone: {
        title: "Your caller id phone number",
        placeholder: "(123) 456-7890",
      },
      targetPhone: {
        title: "Customer number",
        placeholder: "(123) 456-7890",
      },
    };
  }

  /**
   * Display list of messages and dates for this messages
   */
  displayMessagesList(chat: any, activeContact: any) {
    const ln = chat.length;
    return chat.reduce(
      (prev: any, currentMessage: any, index: number) => {
        const sameDay = isSameDay(
          new Date(prev?.lastDay),
          new Date(currentMessage?.date)
        );
        if (!sameDay) {
          prev.items.push(
            <ChatDateItem key={`date-${index}`} date={currentMessage?.date} />
          );
        }
        prev.items.push(
          <MessageItem
            defaultVisible={vsbl(ln, index)}
            key={index}
            scrollTopPosition={this.state.scrollTopPosition}
            msgData={currentMessage}
            currentContact={activeContact}
          />
        );
        return {
          lastDay: sameDay ? prev?.lastDay : currentMessage?.date,
          items: prev.items,
        };
      },
      {
        lastDay: "",
        items: [],
      }
    ).items;
  }

  render() {
    const activeContact =
      this.props.contacts[this.props.activeContactIndex] || {};
    const avatarUrl = activeContact.avatar;
    const isPrimeMember = activeContact?.original?.prime_member;
    const address = activeContact?.original?.address;
    let { firstletter, lastletter } = this.getFIO(activeContact);
    const contactPhone = formattedPhone(activeContact.phone || "");
    const contactIsSelected = this.props.activeContactIndex > -1;
    const originalContact = activeContact.original || {};
    const contactUrl =
      ContactTypes.CUSTOMER === originalContact.type
        ? customerUrl(originalContact.system_item_id)
        : techUrl(originalContact.system_item_id);
    const hasSelectedWorkspace = this.props.selectedWorkspace !== null;

    return (
      <ChatStyles>
        <div className="chat-wrapper">
          {contactIsSelected ? (
            <div className="chat">
              <div className="chat__header">
                <div className="chat__contact">
                  <div className="chat__contact-avatar typo typo-text-14">
                    {avatarUrl ? (
                      <img src={avatarUrl} width="40" height="40" />
                    ) : (
                      <span className="chat__contact-avatar-text">{`${firstletter}${lastletter}`}</span>
                    )}
                  </div>

                  <div className="chat__contact-info">
                    <div className="chat__contact-name">
                      <a
                        href={contactUrl}
                        className="typo typo-text-14 typo-bold"
                        target="_blank"
                      >
                        {activeContact?.name || ""}
                      </a>
                      {isPrimeMember ? (
                        <Icon
                          icon="member"
                          width="45"
                          height="18"
                          classWrapper="chat__contact-member"
                        />
                      ) : (
                        ""
                      )}
                    </div>
                    <div className="chat__contact-address typo typo-text-12">
                      {address || "No address"}
                    </div>
                  </div>

                  {/* <ContactMenu
                      contactType={this.props.contactType}
                      contactData={activeContact}
                      callTo={() => this.toggleOutboundTechModal()}
                      contactInfo={() => this.toggleCustomerInfoModal()}
                    /> */}
                </div>
              </div>
            </div>
          ) : (
            ""
          )}

          {contactIsSelected ? (
            <MessagesStyles
              ref={(ref: any) => {
                this.refMessagesWrap = ref;
                // debugger;
              }}
            >
              {this.props.chatLoadingIndicator ? (
                <Spinner fit color="#3333cc" size={14} margin={3} />
              ) : (
                ""
              )}
              <div className="messages__wrap" id="messages-wrapper">
                {this.displayMessagesList(this.props.chat, activeContact)}
                <div id="end-of-chat"></div>
              </div>
            </MessagesStyles>
          ) : (
            ""
          )}

          {/* {contactIsSelected && !hasSelectedWorkspace ? (
            <WriterContainer onSended={() => this.scrollToBottom()} />
          ) : (
            ""
          )} */}

          {!contactIsSelected ? (
            <div className="chat__empty-message typo typo-h5">
              Select a contact
            </div>
          ) : (
            ""
          )}

          {/* ---------------

          {this.props.contactType === ContactTypes.TECHNICIAN ? (
            <OutboundPopupContainer
              phoneTo={contactPhone}
              show={this.state.techModalShown}
              onHide={() => this.toggleOutboundTechModal()}
              userId={this.state.job.location_id || -1}
              onSelect={(id: number) =>
                this.onChangeOutboundPopupLocation(id, 0)
              }
              onCallStartedSuccsess={(callInfo) => {
                console.log("Technician callInfo: ", callInfo);
              }}
            />
          ) : (
            <OutboundPopupLocations
              show={this.state.techModalShown}
              onHide={() => this.toggleOutboundTechModal()}
              fields={this.outboundFieldNames()}
              locationId={this.state.job.location_id || -1}
              staticTargetNumber={contactPhone}
              onSelect={(id: number, departmentId: number) =>
                this.onChangeOutboundPopupLocation(id, departmentId)
              }
              onCallStartedSuccsess={(callInfo) => {
                console.log("Customer callInfo: ", callInfo);
              }}
            />
          )}
        --------------- */}

          <Modal
            width={400}
            title={`${this.props.contactType === ContactTypes.TECHNICIAN ? "Technician" : "Customer"} info`}
            show={this.state.customerInfoModalShown}
            onHide={() => this.toggleCustomerInfoModal()}
            darkShadow
            closeBtn
          >
            <ContactInfo activeContact={activeContact} />
          </Modal>
        </div>
      </ChatStyles>
    );
  }
}
